import React from "react"
import {findDOMNode} from "react-dom"

import Popover from "../../../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../../../gd-components/gd-popover/popover-position"
import DatepickerContent from "../../../../../../../gd-components/datetime/datepicker/datepicker-content"
import ItemModel from "../../../../../../../model2/item/item-model"
import ProjectTableManager from "../../../../../../../../app/project/table/manager/manager"

// const debug = "FieldProjectEndDate_Popover"
const debug = false

type Props = {
    field    : any
    listItem : ItemModel
    manager  : ProjectTableManager
    parent   : any
    value    : any
}

export default function FieldProjectEndDate_Popover(props: Props) {

    debug && console.log(debug, "render",  props)

    const onSelect = (date:any) => {
        props.parent.hidePopover();
        props.parent.onValueChange(date);
    };

    const value   = props?.value
    const minDate = props.listItem?.project?.startDate


    return (
        <Popover position={PopoverPosition.top()}
                 getTargetFunc={()=>findDOMNode(props.parent)}
                 onClickOutside={()=>{props.parent.hidePopover()}}>

            <DatepickerContent value        = {value}
                               onSelect     = {onSelect}
                               minDate      = {minDate}
            />
        </Popover>
    );
}
